import React from 'react'
import styles from './reversible.module.css'

const ReversibleComponent = ({
  leftElement,
  rightElement,
  isReversed,
  reverseStyles,
  estaterow,
}) => {
  return (
    <div
      className={`${styles.reversiblecontainer} ${
        isReversed ? styles.rowReverse : `${styles.row} ${estaterow}`
      } ${reverseStyles} ${estaterow}`}
    >
      <div className={styles.reverseleft}>{leftElement}</div>
      <div>{rightElement}</div>
    </div>
  )
}

export default ReversibleComponent
